import { cn } from "@/lib/utils";
import { LayoutGrid, List } from "lucide-react";

export type VaultViewMode = "grid" | "list";

export function VaultViewToggle({
	view,
	onChange,
}: {
	view: VaultViewMode;
	onChange: (v: VaultViewMode) => void;
}) {
	return (
		<div className="flex items-center gap-1 rounded-xl border border-border p-1">
			<button
				type="button"
				aria-label="Grid view"
				className={cn(
					"inline-flex min-h-10 min-w-10 items-center justify-center rounded-lg",
					view === "grid"
						? "bg-primary/15 text-primary"
						: "text-muted-foreground",
				)}
				onClick={() => onChange("grid")}
			>
				<LayoutGrid className="size-4" />
			</button>
			<button
				type="button"
				aria-label="List view"
				className={cn(
					"inline-flex min-h-10 min-w-10 items-center justify-center rounded-lg",
					view === "list"
						? "bg-primary/15 text-primary"
						: "text-muted-foreground",
				)}
				onClick={() => onChange("list")}
			>
				<List className="size-4" />
			</button>
		</div>
	);
}
